import React from "react";
import { ScrollTopButton, Spacer, Text } from "#ui";
import { useTranslation } from "#hooks";
import { GeneralPageLayout } from "#components";

export const DataProtection: React.FC = () => {
  const { t } = useTranslation("dataProtection");

  return (
    <GeneralPageLayout>
      <Text text={t("text")} />
      <Spacer size={50} page={"interview"} />
      <ScrollTopButton />
      <Spacer size={20} page={"interview"} />
    </GeneralPageLayout>
  );
};
